/// <reference lib="dom" />
/// <reference lib="dom.iterable" />
import React from "react"
import { DndProvider } from "react-dnd"
import { HTML5Backend } from "react-dnd-html5-backend"
import ReactDOM from "react-dom/client"
import { ChakraProvider } from "@chakra-ui/react"

import "./instrument"

import App from "./App"
import theme from "./theme"

import "./index.css"

window._env_ = window._env_ || {
  LEKIMA_CONSOLE_API_ENDPOINT: import.meta.env.VITE_ENDPOINT,
  LEKIMA_CONSOLE_APIV2_ENDPOINT: import.meta.env.VITE_ENDPOINTV2,
}

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <ChakraProvider theme={theme}>
      <DndProvider backend={HTML5Backend}>
        <App />
      </DndProvider>
    </ChakraProvider>
  </React.StrictMode>,
)
